import { variant, type InferOutput } from "valibot"
import { StoredItemMetaLocalStorageSchema } from "./StoredItemMetaLocalStorage.type"
import { StoredItemMetaPresetSchema } from "./StoredItemMetaPreset.type"

export const StoredItemMetaUnionSchema = variant('kind', [
  StoredItemMetaPresetSchema,
  StoredItemMetaLocalStorageSchema,
])

export type StoredItemMetaUnion = InferOutput<typeof StoredItemMetaUnionSchema>
